import { useState } from 'react';
import UpgradeModal from './UpgradeModal';

interface WorkspacePaywallProps {
  plan: string;
  currentCount: number;
  limit: number;
}

export default function WorkspacePaywall({ plan, currentCount, limit }: WorkspacePaywallProps) {
  const [showModal, setShowModal] = useState(false);

  const isFreePlan = plan === 'free';
  const tier = isFreePlan ? 'pro' : 'enterprise';
  const title = isFreePlan ? 'Need more workspaces?' : 'Workspace limit reached';
  const description = isFreePlan
    ? `You're using ${currentCount} of ${limit} workspace${limit === 1 ? '' : 's'} on your free plan. Upgrade to Pro to create up to 5 workspaces.`
    : `You're using ${currentCount} of ${limit} workspaces on your ${plan} plan.`;

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="w-full text-left px-4 py-3"
      >
        <p className="text-xs text-gray-500 mb-1">
          {currentCount}/{limit} workspace{limit === 1 ? '' : 's'} used
        </p>
        {isFreePlan ? (
          <p className="text-xs font-medium text-primary-600 hover:text-primary-700">
            Upgrade to Pro for more workspaces
          </p>
        ) : (
          <p className="text-xs text-gray-400">
            Workspace limit reached
          </p>
        )}
      </button>

      <UpgradeModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={title}
        description={description}
        buttonText={isFreePlan ? 'Upgrade to Pro' : 'Contact Sales'}
        tier={tier}
        icon={
          <svg className="w-7 h-7 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        }
      />
    </>
  );
}
